import appReducer from './appSlice'

export const loadingActionReducer = appReducer
